@if (isImpersonating$ | async) {
  <div class="x-small-reg-text f-row impersonate-container">
    <span>Impersonating</span>
    <span class="bold" >{{displayName$ | async}}</span>
  </div>
}
<div class="buttons f-row">
  @if (isImpersonating$ | async) {
    <button class="x-small-medium-text" (click)="openModal()">Change User</button>
  }
  @if (isImpersonating$ | async) {
    <button class="x-small-medium-text" (click)="stopImpersonating()">Stop Impersonating</button>
  }
</div>
@if (modalOpen) {
  <app-impersonate-modal (closeModal)="onModalClose()"></app-impersonate-modal>
}
